<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M14.9722 9.73807C15.6687 9.14115 15.2465 8 14.3293 8C14.1155 8 13.9075 8.06933 13.7365 8.19759L10 11L6.26345 8.1976C6.09244 8.06934 5.88445 8.00001 5.67069 8.00001C4.75347 8 4.33133 9.14114 5.02773 9.73806L9.99998 14L14.9722 9.73807Z"
    fill="currentColor"
  />
</svg>
